import { Divider, InputAdornment, TextField, styled, Tooltip, Typography } from "@mui/material";
import React from "react";
import { Box } from "@mui/material";
import { 
    ColumnsPanelTrigger, 
    FilterPanelTrigger, 
    GridColDef, 
    GridDataSource, 
    GridDataSourceCache, 
    GridDataSourceCacheDefault, 
    GridGetRowsParams, 
    GridGetRowsResponse, 
    GridOverlay, 
    GridRenderCellParams, 
    GridRowModesModel, 
    GridSortCellParams, 
    GridSortModel, 
    GridToolbarContainer, 
    QuickFilter, 
    QuickFilterClear, 
    QuickFilterControl, 
    QuickFilterTrigger, 
    ToolbarButton, 
    useGridApiRef 
} from "@mui/x-data-grid";
import ViewColumnIcon from '@mui/icons-material/ViewColumn';
import FilterListIcon from '@mui/icons-material/FilterList';
import RefreshIcon from '@mui/icons-material/Refresh';
import SearchIcon from '@mui/icons-material/Search';
import CancelIcon from '@mui/icons-material/Cancel';
import Badge from '@mui/material/Badge';
import DownloadIcon from '@mui/icons-material/Download';
import CustomDataGrid from "../../Common/CustomDataGrid";
import SquareIcon from '@mui/icons-material/Square';
import WhisperPopover from "../Common/WhisperPopover";
import { formatNumber } from "../../Common/FormatNumber";

const StyledQuickFilter = styled(QuickFilter)({
    '& .MuiDataGrid-toolbar': {
      padding: '0 0 16px 0',
    },
  });
  
const StyledToolbarButton = styled(ToolbarButton)<{ ownerState: OwnerState }>(
    ({ theme, ownerState }) => ({
      gridArea: '1 / 1',
      width: 'min-content',
      height: 'min-content',
      zIndex: 1,
      opacity: ownerState.expanded ? 0 : 1,
      pointerEvents: ownerState.expanded ? 'none' : 'auto',
      transition: theme.transitions.create(['opacity']),
    }),
);

type OwnerState = {
    expanded: boolean;
};

const StyledTextField = styled(TextField)<{
  ownerState: OwnerState;
}>(({ theme, ownerState }) => ({
  gridArea: '1 / 1',
  overflowX: 'clip',
  width: ownerState.expanded ? 260 : 'var(--trigger-width)',
  opacity: ownerState.expanded ? 1 : 0,
  transition: theme.transitions.create(['width', 'opacity']),
}));

// function CustomToolbar(props: any) {
//     const { customer_id } = props;
//     return (
//         <GridToolbarContainer>
//             <Typography variant="h6" component="div" sx={{ flexGrow: 1, padding: '8px 16px' }}>Data Whisper Feed</Typography>
//             <Tooltip title="Refresh data">
//                 <ToolbarButton>
//                     <RefreshIcon fontSize="small" />
//                 </ToolbarButton>
//             </Tooltip>
//             <Divider orientation="vertical" variant="middle" flexItem sx={{ mx: 0.5 }} />
//             <Tooltip title="Columns">
//                 <ColumnsPanelTrigger render={<ToolbarButton />}>
//                     <ViewColumnIcon fontSize="small" />
//                 </ColumnsPanelTrigger>
//             </Tooltip>
//             <Tooltip title="Filters">
//                 <FilterPanelTrigger
//                     render={(props, state) => (
//                     <ToolbarButton {...props} color="default">
//                         <Badge badgeContent={state.filterCount} color="primary" variant="dot">
//                             <FilterListIcon fontSize="medium" />
//                         </Badge>
//                     </ToolbarButton>
//                     )}
//                 />
//             </Tooltip>
//             <Tooltip title="Export">
//                 <ToolbarButton onClick={() => window.location.href = '/customers/' + customer_id + '/export/'}>
//                     <DownloadIcon fontSize="small" />
//                 </ToolbarButton>
//             </Tooltip>
//             <StyledQuickFilter>
//                 <QuickFilterTrigger
//                     render={(triggerProps, state) => (
//                     <Tooltip title="Search" enterDelay={0}>
//                         <StyledToolbarButton
//                             {...triggerProps}
//                             ownerState={{ expanded: state.expanded }}
//                             color="default"
//                             aria-disabled={state.expanded}
//                             >
//                             <SearchIcon fontSize="small" />
//                         </StyledToolbarButton>
//                     </Tooltip>
//                     )}
//                 />
//                 <QuickFilterControl
//                     render={({ ref, ...controlProps }, state) => (
//                     <StyledTextField
//                         {...controlProps}
//                         ownerState={{ expanded: state.expanded }}
//                         inputRef={ref}
//                         aria-label="Search"
//                         placeholder="Search..."
//                         size="small"
//                         slotProps={{
//                         input: {
//                             startAdornment: (
//                             <InputAdornment position="start">
//                                 <SearchIcon fontSize="small" />
//                             </InputAdornment>
//                             ),
//                             endAdornment: state.value ? (
//                             <InputAdornment position="end">
//                                 <QuickFilterClear
//                                 edge="end"
//                                 size="small"
//                                 aria-label="Clear search"
//                                 material={{ sx: { marginRight: -0.75 } }}
//                                 >
//                                 <CancelIcon fontSize="small" />
//                                 </QuickFilterClear>
//                             </InputAdornment>
//                             ) : null,
//                             ...controlProps.slotProps?.input,
//                         },
//                         ...controlProps.slotProps,
//                         }}
//                     />
//                     )}
//                 />
//                 </StyledQuickFilter>
//         </GridToolbarContainer>
//     );
// }


export default function CustomerIndex(props: { value: string, customer_index: string, customer_id: number, mode: string }){
    const customer_id = props.customer_id;
    // const [customer_index, setCustomerIndex] = React.useState(JSON.parse(props.customer_index || '{}'));
    const apiRef = useGridApiRef();
    const [lowTTLCache, setLowTTLCache] = React.useState<GridDataSourceCache>(() => new GridDataSourceCacheDefault({ ttl: 1000 * 10 }));
    const [rowModesModel, setRowModesModel] = React.useState<GridRowModesModel>({});
    const [columns, setColumns] = React.useState<GridColDef[]>([
        {
            field: 'color',
            headerName: '',
            width: 20,
            align: 'center',
            headerAlign: 'center',
            type: 'string',
            filterable: false,
            renderCell: (params: GridRenderCellParams) => {
                return <SquareIcon fontSize="small" style={{ color: params.row.color }} />;
            },
        },
        {
            field: 'channel_descr',
            headerName: 'Type',
            renderHeader: (params) => {
                return <span style={{ fontWeight: 'bold' }}>{params.colDef.headerName as string}</span>;
            },
            width: 250,
            align: 'center',
            headerAlign: 'center',
            type: 'string',
            sortable: true,
            sortComparator: (a: any, b: any) => {
                return a[a.sortModel[0].field] - b[b.sortModel[0].field];
            },
            renderCell: (params: GridRenderCellParams) => {
                return (
                    <WhisperPopover title={params.value} content={params.row.whisper} color="blue" />
                );
            },
        },
        // {
        //     field: 'condition',
        //     headerName: 'Condition',
        //     renderHeader: (params) => {
        //         return <span style={{ fontWeight: 'bold' }}>{params.colDef.headerName as string}</span>;
        //     },
        //     flex: 1,
        //     align: 'center',
        //     headerAlign: 'center',
        //     type: 'number',
        //     sortable: true,
        //     filterable: false,
        //     sortComparator: (a: any, b: any) => {
        //         return a[a.sortModel[0].field] - b[b.sortModel[0].field];
        //     }
        // },
        // {
        //     field: 'control',
        //     headerName: 'Goal',
        //     renderHeader: (params) => {
        //         return <span style={{ fontWeight: 'bold' }}>{params.colDef.headerName as string}</span>;
        //     },
        //     flex: 1,
        //     align: 'center',
        //     headerAlign: 'center',
        //     type: 'number',
        //     sortable: true,
        //     filterable: false,
        //     sortComparator: (a: any, b: any) => {
        //         return a[a.sortModel[0].field] - b[b.sortModel[0].field];
        //     },
        //     renderCell: (params: GridRenderCellParams) => {
        //         return <span>{formatNumber(params.value)}</span>;
        //     },
        // },
        // {
        //     field: 'difference',
        //     headerName: 'Difference',
        //     renderHeader: (params) => {
        //         return <span style={{ fontWeight: 'bold' }}>{params.colDef.headerName as string}</span>;
        //     },
        //     flex: 1,
        //     width: 200,
        //     align: 'center',
        //     headerAlign: 'center',
        //     type: 'number',
        //     sortable: true,
        //     filterable: false,
        //     sortComparator: (a: any, b: any) => {
        //         return a[a.sortModel[0].field] - b[b.sortModel[0].field];
        //     },
        //     renderCell: (params: GridRenderCellParams) => {
        //         return <span style={{ color: params.value > 0 ? (props.mode === 'light' ? 'green' : 'lightgreen') : 'red' }}>{formatNumber(params.value)}</span>;
        //     },
        // },
        {
            field: 'rev_impact',
            headerName: '',
            renderHeader: (params) => {
                return <span style={{ textAlign: 'center', fontWeight: 'bold' }}>Revenue Impact</span>;
            },
            width: 120,
            align: 'center',
            headerAlign: 'center',
            type: 'number',
            sortable: true,
            filterable: false,
            sortComparator: (a: any, b: any) => {
                return a[a.sortModel[0].field] - b[b.sortModel[0].field];
            },
            renderCell: (params: GridRenderCellParams) => {
                return <span>{formatNumber(params.value || 0)}</span>;
            },
        },
        {
            field: 'gp_impact',
            headerName: '',
            renderHeader: (params) => {
                return <span style={{ textAlign: 'center', fontWeight: 'bold' }}>Profit Impact</span>;
            },
            width: 120,
            align: 'center',
            headerAlign: 'center',
            type: 'number',
            sortable: true,
            filterable: false,
            sortComparator: (a: any, b: any) => {
                return a[a.sortModel[0].field] - b[b.sortModel[0].field];
            },
            renderCell: (params: GridRenderCellParams) => {
                const value = Number(params.value || 0);
                return <span style={{ color: value > 0 ? 'darkgreen' : 'red' }}>{formatNumber(value)}</span>;
            },
        },
        {
            field: 'whisper',
            headerName: 'Whisper',
            renderHeader: (params) => {
                return <span style={{ fontWeight: 'bold' }}>{params.colDef.headerName as string}</span>;
            },
            width: 800,
            align: 'center',
            headerAlign: 'center',
            type: 'string',
            sortable: false,
            renderCell: (params: GridRenderCellParams) => {
                return <span style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>{params.value}</span>;
            },
        }
    ]);


    let gridDataSource: GridDataSource = {
        getRows: async (params: GridGetRowsParams): Promise<GridGetRowsResponse> => {
            let urlDict = {};
      
            //   if (params.paginationModel.page > 0) {
            urlDict = {paginationModel: JSON.stringify(params.paginationModel)};
            //   }
            if (params.filterModel.items.length > 0) {
                // urlDict = {filterModel: JSON.stringify(params.filterModel)};
                urlDict = { ...urlDict, filterModel: JSON.stringify(params.filterModel) };  
            }
            if (params.sortModel.length > 0) {
                // urlDict = {sortModel: JSON.stringify(params.sortModel)};
                urlDict = { ...urlDict, sortModel: JSON.stringify(params.sortModel) };
            }
        
            const urlParams = new URLSearchParams(urlDict);
            const urlParamsString = urlParams.size > 0 ? `${urlParams.toString()}&value=${props.value}&entity_id=${localStorage.getItem('entity_id')}` : `?value=${props.value}&entity_id=${localStorage.getItem('entity_id')}`;
            const response = await fetch(`/customers/${customer_id}/whisper-feed/?${urlParamsString}`, {
                method: 'GET',
            });
            const data = await response.json();
            return {
                rows: data.rows,
                rowCount: data.rowCount,
            };
        },
    }
    return (
        <Box sx={{ display: 'flex', width: '100%', height: 'auto' }}>
            {/* <Card
                sx={theme => ({
                    width: '100%',
                    height: 'auto',
                    bgcolor: props.mode === 'light' ? 'white !important' : '#192841 !important',
                    borderRadius: 2,
                    border: 0,
                    boxShadow: 'none !important',
                    // filter: `drop-shadow(0px 0px 1px ${
                    //     theme.palette.mode === 'dark'
                    //         ? 'rgba(255,255,255,0.10)'
                    //         : 'rgba(0,0,0,0.32)'
                    // })`
                })}
            >
                <CardContent sx={{ height: '100%' }}> */}
                    <CustomDataGrid 
                        message="No data whisper feed found." 
                        mode={props.mode} 
                        columns={columns} 
                        gridDataSource={gridDataSource} 
                        sortModel={[]}
                        apiRef={apiRef} 
                        rowModesModel={rowModesModel} 
                        lowTTLCache={lowTTLCache} 
                        title="Data Whisper Feed" 
                        navigate={false}
                        url={`/customers/${customer_id}/?value=${props.value}`} 
                        exportUrl={`/customers/${customer_id}/export/?value=${props.value}`} 
                    />
                {/* </CardContent> */}
            {/* </Card> */}
        </Box>
    )
}